//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "VbacRiskScoreForVaginalDelivery",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
      },
      otherForm: {
        ageOver40: "0",
        value: "0",
        value1: "0",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: "没有阴道分娩史" },
        { value: "1", name: "初次剖宫产前有阴道分娩史" },
        { value: "2", name: "初次剖宫产后有阴道分娩史" },
        { value: "4", name: "初次剖宫产前后均有阴道分娩史" },
      ],
      dataList1: [
        { value: "0", name: "<25%" },
        { value: "1", name: "25%-75%" },
        { value: "2", name: "75%-100%" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let otherForm = JSON.parse(JSON.stringify(self.otherForm));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      let points =
        (otherForm.ageOver40 *1 ? 2 : 0) +
        (otherForm.value*1 ? 1 : 0) +
        (otherForm.value1*1 ? 1 : 0) +
        result;
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(points);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/VbacRiskScoreForVaginalDelivery.vue